export const SHOW_TRAY = 'SHOW_TRAY';

export const showTray = (component, options) => dispatch => {
  dispatch({ type: SHOW_TRAY, isOpen: true, component, options: { ...DEFAULT_STATE.options, onClose: () => dispatch(hideTray()), ...options } });
};

export const HIDE_TRAY = 'HIDE_TRAY';

export const hideTray = () => dispatch => {
  dispatch({ type: HIDE_TRAY, isOpen: false });
};

export const UPDATE_TRAY_PROPS = 'UPDATE_TRAY_PROPS';

export const updateTrayProps = props => dispatch => {
  dispatch({ type: UPDATE_TRAY_PROPS, props });
};

const DEFAULT_STATE = {
  isOpen: false,
  component: null,
  options: {
    size: 'sm',
    title: '',
    placement: 'right',
    variant: 'primary',
    overlayClose: false,
    params: {},
    onClick: () => {},
    onClose: () => {},
    motionPreset: 'slideInRight'
  },
  props: {}
};
const trayReducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case SHOW_TRAY:
      return { ...state, ...action };
    case HIDE_TRAY:
      return { ...DEFAULT_STATE };
    case UPDATE_TRAY_PROPS:
      return { ...state, props: action.props };
    default:
      return state;
  }
};

export default trayReducer;

export const selectTrayOpen = state => state.tray.isOpen;
export const selectTrayOptions = state => state.tray.options;
export const selectTrayComponent = state => state.tray.component;
export const selectTrayTitleComponent = state => state.tray.options.titleComponent;
export const selectTrayProps = state => state.tray.props;
